module.exports = __webpack_public_path__ + "media/images/ready/icon-magnify-6aefe67d49d7a945f657cbc6e4ae3554.svg";